import { Col, DatePicker, Form, Radio, Row } from "antd";
import React, { FC } from "react";

type CovidCaseDetailsProps = {
  form: any;
  portalSubmission: any;
  isApproved: boolean;
};

const CovidCaseDetails: FC<CovidCaseDetailsProps> = ({ form, portalSubmission, isApproved }) => {
    const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Covid Case Details and Treatment/Surgery Date
      </div>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Is this COVID case"
              name="covidPatientOrNot"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select covid patient or not",
                },
              ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Yes",
                    value: "true",
                  },
                  {
                    label: "No",
                    value: "false",
                  },
                ]}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Treatment Start Date"
              name="surgeryDate"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input Treatment Start Date",
                },
              ]}
            >
              <DatePicker
                placeholder="Please input Treatment Start Date"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
                disabled={portalSubmission}
              />
              </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CovidCaseDetails;
